import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { unloadDepart, viewDepart } from '../../modules/deptModule/depart';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import AuthDeptMenuTemplate from '../../components/authmenumng/AuthDeptMenuTemplate';
import AuthDepartViewContainer from './AuthDepartMenusContainer';
import AuthDepartMenusContainer from './AuthDepartMenusContainer';

const AuthDeptMenuContainer = () => {

    const { id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [titleData, setTitleData] = useState(null);

    const { depart, error, loading } = useSelector(
        ({ departModule, loading }) => ({
            depart: departModule.depart.depart,
            error: departModule.depart.error,
            loading: loading['depart/VIEW_DEPART'],
        }),
    );


    useEffect(() => {
        dispatch(viewDepart(id));

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadDepart());
        };
    }, [dispatch, id]);

    useEffect(() => {
        if (depart) {
            let title = {
                name: depart.dptNm
            };
            setTitleData(title);
        }

    }, [depart, id]);


    


    return (
        <AuthDeptMenuTemplate depart={depart} loading={loading} error={error}>
            <AuthDepartMenusContainer depart={depart} />
        </AuthDeptMenuTemplate>
    )
}

export default AuthDeptMenuContainer